// extracted by mini-css-extract-plugin
module.exports = {"EstimateHeader":"Page_EstimateHeader__oqs1g","EstimateHeaderTitle":"Page_EstimateHeaderTitle__hUPBH"};